module.exports = __webpack_public_path__ + "img/_010.18999a11.png";